// extracted by mini-css-extract-plugin
export default {"input":"Weight_input__Eh9qw"};